export interface ChatHistoryItem {
    id: number;
    created: number;
    fromUser: {
        id: number;
        created: number;
        avatar: {
            id: number;
            upload: string;
            url: string;
            attachmentType: string;
        };
        contact: any;
        payment: any;
        apiHost: string;
    };
    message: string;
}

export interface UploadHistoryItem {
    id: number;
    upload: string;
    url: string;
    attachmentType: string;
    created: number;
}

export interface DispatchHistoryItem {
    id: number;
    created: number;
    vehicle: {
        driver: { 
            contact: {
                name: string,
                email: string,
                phone: string
            }
        },
        id: number;
        groupName: string | null;
    };
    job: {
        id: number;
    };
    dispatchType: string;
    overflowReturnReason: string | null;
    dispatchAudit: {
        type: string;
        user: {
            id: number;
            created: number;
            avatar: {
                id: number | null;
                created: number | null;
                url: string;
                attachmentType: string | null;
            };
            contact: { name: string; phone: string; email: string };
            payment: { payPal: string };
            apiHost: string;
        };
    };
}

export interface JobHistoryResponse {
    id: number;
    name: string;
    status: string;
    driver: {
        id: number;
        created: number;
        avatar: {
            id: number | null;
            created: number | null;
            url: string | null;
            attachmentType: string | null;
        };
        contact: { name: string; phone: string; email: string };
        payment: { payPal: string };
        apiHost: string;
    };
    customerContact: {
        name: string;
        email: string;
        phone: string;
    };
    created: number;
    started: number;
    completed: number;
    tasks: {
        id: number;
        deadline: number | null;
        completed: number;
        timeDeviationSeconds: number | null;
        geoZone: {
            id: number | null;
            address: string;
        };
    }[];
    issues: {
        id: number;
        created: number;
        type: string;
    }[];
    uploads: UploadHistoryItem[];
    dispatches: DispatchHistoryItem[];
    rating: number | null;
    chat: ChatHistoryItem[];
}

export const openPhotoInNewTab = (photoUrl: string): void => {
    if (!photoUrl) return;

    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = photoUrl;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export type JobHistoryModal = 'PHOTO' | 'CHAT' | 'AUDIT' | null;
